import DesktopFooter from "./DesktopFooter/DesktopFooter";
import MobileFooter from "./MobileFooter/MobileFooter";

export default function Footer() {
  return (
    <>
      <DesktopFooter />
      <MobileFooter />
    </>
  );
}
